import React from 'react';
import { CreateEngagementWizard } from '../../components/portal/CreateEngagementWizard';

/**
 * New Engagement Page
 *
 * Wraps the CreateEngagementWizard component as a full page.
 * Route: /portal/projects/new
 *
 * Supports query params:
 * - partyId: Pre-select a client (e.g., from client detail page)
 */
export const NewEngagement: React.FC = () => {
  return <CreateEngagementWizard />;
};

export default NewEngagement;
